(function ($) {

  Drupal.behaviors.applicationFormMotivations = {
    attach: function (context) {

      var $motivationText = $("#edit-motivation");
      var $motivationFile = $("#edit-saph-user-application-motivation-file");
      var $motivationFileHidden = $("#edit-saph-user-application-motivation-file_hidden");
      if($motivationText.length > 0 && $motivationFile.length > 0) {
        $motivationText.on("change", updateMotivationInputFields);
        $motivationFile.on("change", updateMotivationInputFields);
      }
      if($motivationFileHidden){
        $motivationFileHidden.on("change", updateMotivationInputFields);
      }

      updateMotivationInputFields();

      /*
      * special handling for motivation fields
      * one file is mandatory
      * the other one optional
      */

      function updateMotivationInputFields(){
        //console.log("updateMotivationInputFields()");

        var $motivationText = $("#edit-motivation");
        var $motivationTextFF = $motivationText.closest(".formField");
        var $motivationFile = $("#edit-saph-user-application-motivation-file");
        var $motivationFileHidden = $("#edit-saph-user-application-motivation-file_hidden");
        var $motivationFileFF = $motivationFile.closest(".formField");

        var motivationValid = false;
        if($motivationText.val() != ""){
          motivationValid = true;
        }
        if($motivationFile.val() != ""){
          motivationValid = true;
        }
        if($motivationFileHidden && $motivationFileHidden.val() && $motivationFileHidden.val() != ""){
          motivationValid = true;
        }

        $motivationTextFF.removeClass("formField-mandatory");
        $motivationTextFF.removeClass("formField-error");
        $motivationTextFF.removeClass("formField-hasErrorHandling");
        $motivationTextFF.addClass("formField-hasErrorHandling");
        $motivationTextFF.children(".formField-error-message").hide();

        if($motivationTextFF.find(".formField-multiTextField-frame").length > 0){
          $motivationTextFF.find(".formField-multiTextField-frame").removeClass("formField-multiTextField-input-error");
        }
        if($motivationTextFF.find(".forms-hint-text").length > 0){
          $motivationTextFF.find(".forms-hint-text").hide();
        }

        $motivationFileFF.removeClass("formField-mandatory");
        $motivationFileFF.removeClass("formField-error");
        $motivationFileFF.removeClass("formField-hasErrorHandling");
        $motivationFileFF.addClass("formField-hasErrorHandling");
        $motivationFileFF.find(".formField-error-message").hide();

        if(!motivationValid){
          $motivationTextFF.addClass("formField-mandatory");
          $motivationFileFF.addClass("formField-mandatory");
        }
      }
    }
  }

})(jQuery);
